import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { AuthorizationService } from 'services/authorization.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [TranslateModule, SpinnerComponent],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent {
  constructor(
    private authService: AuthorizationService,
    private route: ActivatedRoute
  ) {}

  isLoading(): boolean {
    const loading = this.route.snapshot.queryParamMap.get('loading');

    return !!loading;
  }

  handleLogin(): void {
    this.authService.login();
  }
}
